import { restApiIP } from "@plannel/services/utils/rest-api";

const getMonthlyInventoryTrend = (params) => {
  return restApiIP.get("/api/inv-mgmt-overview/monthly-inventory-trend", {params});
};

const getWarningDataset = (params) => {
  return restApiIP.get("/api/inv-mgmt-overview/warning-dataset", {params});
}

const inventoryMgmtOverviewService = {
  getMonthlyInventoryTrend,
  getWarningDataset
};

export default inventoryMgmtOverviewService;